import { render, staticRenderFns } from "./marketing-list-header.vue?vue&type=template&id=44816ea2"
import script from "./marketing-list-header.vue?vue&type=script&lang=js"
export * from "./marketing-list-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports